import { render, staticRenderFns } from "./StepContactDetails.vue?vue&type=template&id=385913da&"
import script from "./StepContactDetails.vue?vue&type=script&lang=js&"
export * from "./StepContactDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports